import { motion, AnimatePresence } from "framer-motion";
import { ReactNode, type FC } from "react";

export const AnimateAppearanceWrapper: FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ delay: 0.1 }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
